import { useState } from "react";
import { RouteParcel } from "../../models/RouteParcel";
import RouteParcelsGridHeaders from "./RouteParcelsGridHeaders";
import RouteParcelView from "./RouteParcelView";

function ReroutingParcelsView( { newRouteNumber, routeParcels, onConfirm }: { newRouteNumber: string, routeParcels: RouteParcel[], onConfirm: (parcels: RouteParcel[]) => void }) {

    const [selectedParcels, setSelectedParcels] = useState<RouteParcel[]>(routeParcels);

    const handleParcelSelected = (parcel: RouteParcel) => {
        if(parcel.selected)
            setSelectedParcels([...selectedParcels, parcel]);
        else
            setSelectedParcels(selectedParcels.filter(p => p.controlNumber !== parcel.controlNumber));

    }

    return(
        <div>
            <div className="grid grid-cols-12 text-center text-black">
                <div className="col-span-12" >Rerouting to {newRouteNumber}</div>
                    <RouteParcelsGridHeaders></RouteParcelsGridHeaders>
                <ul className="col-span-12">
                    <div>
                    {routeParcels.map((rp) =>
                        <RouteParcelView key={rp.controlNumber !== 0 ? rp.controlNumber : rp.accountNumber.toString() + rp.trackingNumber} routeParcel={rp} onSelected={handleParcelSelected}/>
                    )}
                    </div>
                </ul>
            </div>
            
            <footer className="border-t-2 border-black grid grid-cols-12 sticky bottom-0 p-2 bg-tpc-portal-banner-dark h-12">
                {routeParcels.some(rp => rp.selected) && <div className="cursor-pointer border-2 border-black text-center col-end-13 col-span-2 bg-gls-logo-blue text-gls-logo-yellow p-2" onClick={() => onConfirm(selectedParcels)}>Confirm</div>}
            </footer>
        </div>
    )

}

export default ReroutingParcelsView;